<template>
    <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
      <feather-icon icon="SearchIcon" v-show="!isOrphan"  svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="selectRecord"  />
      <feather-icon icon="CheckCircleIcon"  svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" v-show="isEnabled && !isOrphan" @click="openImportConfirm"  />
      <feather-icon icon="XIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="openCancelImportation" v-show="!isEnabled && !isOrphan"   />
    </div>
</template>

<script>
import SampleStatusEnum from '../../SampleStatusEnum';
export default {
  name: 'SampleActionsCellRenderer',
  computed: {
    isEnabled() {
      return this.params.data.status === SampleStatusEnum.NotImported;
    },
    isOrphan() {
      return this.params.data.status === SampleStatusEnum.Orphan;
    }
  },
  methods: {
    selectRecord () {
      this.params.context.componentParent.selectSample(this.params.data);
    },
    openImportConfirm() {
      this.$vs.dialog({
        type: "confirm",
        color: "warning",
        title: name,
        text: this.$t('GradeControl.Sample.ConfirmSingleImport'),
        accept: this.import
      });
    },

    import () {
      this.params.context.componentParent.doImportation(this.params.data);
    },
 
    openCancelImportation() {
      this.$vs.dialog({
        type: "confirm",
        color: "warning",
        title: name,
        text: this.$t('GradeControl.Sample.ConfirmCancelImport'),
        accept: this.cancelImportation
      });
    },

    cancelImportation () {
      this.params.context.componentParent.cancelImportation(this.params.data);
    }
  }
}
</script>
